import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: 0,
    margin: 0,
  },
  main: {
    width: "100%",
  },
  heading: {
    fontSize: 36,
    fontWeight: 900,
    padding: theme.spacing(5),
  },
  tabsSection: {
    padding: theme.spacing(2, 5),
    borderBottom: "1px solid #979797",
    "& .MuiTabs-root": {
      minHeight: 0,
      "& .MuiTabs-flexContainer": {
        alignItems: "center",
        gap: 40,
        "& .MuiTab-root": {
          minWidth: 0,
          minHeight: 0,
          fontSize: 18,
          fontWeight: 400,
          color: "#02489D",
          padding: 0,
          "&.Mui-selected": {
            fontWeight: 700,
          },
        },
      },
      "& .MuiTabs-indicator": {
        display: "none",
      },
    },
  },
  loading: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2, 0, 0, 50),
    },
  },
  repricingTool: {
    padding: theme.spacing(5),
    "& .formContainer": {
      width: "50%",
      "& .formLabel": {
        color: "#333333",
        fontSize: 18,
        fontWeight: 700,
      },
      "& .textFieldInput": {
        "& .MuiInputBase-root": {
          width: 64,
          height: 38,
          borderRadius: 6,
          backgroundColor: "#F1F1F1",
          "& .MuiInputBase-input": {
            fontSize: 21,
            fontWeight: 400,
            padding: 6,
          },
        },
      },
      "& .selectFieldInput": {
        "&.MuiInputBase-root": {
          width: 357,
          height: 39,
          borderRadius: 6,
          backgroundColor: "#ECECEC",
          "& .MuiInputBase-input": {
            color: "#333333",
            fontSize: 18,
            fontWeight: 700,
            padding: 8,
          },
        },
      },
      "& .radioInput": {
        "& .MuiRadio-root": {
          paddingTop: 7,
          paddingBottom: 7,
        },
        "& .MuiFormControlLabel-label": {
          fontSize: 18,
          fontWeight: 400,
        },
      },
      "& .inlineField": {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        "&:not(:first-child)": {
          marginTop: 12,
        },
        "& .formSubLabel": {
          color: "#333333",
          fontSize: 18,
          fontWeight: 400,
        },
        "& .inlineTextbox": {
          display: "inline-flex",
          alignItems: "center",
          gap: 17,
        },
      },
      "& .formBtnBox": {
        marginTop: 12,
        "& button": {
          minWidth: 116,
          fontSize: 15,
          fontWeight: 700,
          borderRadius: 6,
          "& .formSubmit": {
            backgroundColor: "#02489D",
            color: "#FFFFFF",
          },
        },
      },
    },
  },
  errorLog: {
    "& .subHeader": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#ECECEC",
      padding: theme.spacing(1.5),
      "& .dateFilter": {
        display: "flex",
        alignItems: "center",
        gap: 38,
        "& .icon": {
          color: "#02489D",
          height: 24,
          width: 24,
          "& svg.MuiSvgIcon-root": {
            fontSize: 20,
          },
        },
        "& .date": {
          minWidth: 82,
          color: "#02489D",
          fontSize: 18,
          fontWeight: 400,
          textAlign: "center",
        },
      },
    },
    "& .tableBox": {
      width: "100%",
      "& .MuiTable-root": {
        color: "#333333",
        fontSize: 16,
        "& .MuiTableHead-root": {
          backgroundColor: "#ECECEC",
          "& .MuiTableRow-root": {
            "& .MuiTableCell-root": {
              fontSize: 16,
              fontWeight: 700,
              color: "#333333",
              padding: "12px 8px 12px 8px",
              borderBottom: 0,
              "&:first-child": {
                paddingLeft: "24px",
              },
            },
          },
        },
        "& .MuiTableBody-root": {
          "& .MuiTableRow-root": {
            "& .MuiTableCell-root": {
              fontSize: 16,
              fontWeight: 400,
              color: "#333333",
              padding: "4px 8px 4px 8px",
              borderBottom: 0,
              "&:first-child": {
                paddingLeft: "24px",
              },
            },
            "&:first-child .MuiTableCell-root": {
              paddingTop: "16px",
            },
          },
        },
      },
    },
  },
  headingAlert: {
    padding: theme.spacing(0, 0, 2, 0),
  },
  alertRoot: {
    marginTop: 24,
  },
}));

export default useStyles;
